export default {
    colors: [
        '#1D889C',
        // '#68e255',
        '#002C3B',
        '#69D4E8',
        // '#e25568',
        // '#55e28a',
        // '#44c302',
        // '#91f4ad',
        // '#d6fe76',
        // '#147d02',
        // '#847567',
        // '#b6ef33',
        // '#4dc1b8',
        // '#6aee20',
        '#2C46D3',
        '#52A28F',
        '#AAF098',
        '#EEAF35',
        '#469b25',
        '#0a1792',
        '#a58468',
        '#4ed430',
        '#346b5f',
        '#5c3e96',
        '#d8f379',
        '#8f2363',
        '#d055e2',
        '#ade255',
        '#D44917',
        '#e2d055',
        '#55ade2',
        '#5568e2',
        '#55e2d0',
        '#249CA9',
        '#88e015',
        '#6F7908',
        '#680dbe',
        '#e255ad',
        '#8a56e2',
        '#013440',
        '#c42cd9',
        '#b51e36',
        '#FFBF41',
        '#AB9A52',
        '#D97925',
        '#686B30',
        '#EE8943',
        '#fd5959',
        '#AB1A25',
        '#97AF25',
        '#158471',
        '#41342C',
        '#354504',
        '#FF4411',
        '#121D2B',
        '#D3FF82',
        '#111B1C',
        '#9388ca',
        '#67274a',
        '#796e2d',
        '#2e8450',
        '#c961fc',
        '#71ada5',
        '#d96f3b',
        '#7da522',
        '#ce11e8',
        '#fc3e0e',
        '#4e24e7',
        '#3781db',
        '#6b4eb6',
        '#c3dc37',
        '#8c2a60',
        '#524089',
        '#64b943',
        '#751599',
        '#9ce463',
        '#e40419',
        '#7f6f96',
        '#93022e',
        '#c119ad',
        '#4f709e',
        '#b88d45',
        '#6bc134',
        '#53c934',
        '#f97884',
        '#8269f3',
        '#0ba7b2',
        '#d27a74',
        '#7995a1',
        '#2d4f7b',
        '#1e6712',
        '#fcb7ae',
        '#a75380',
        '#b0214c',
        '#b285e4',
        '#2522ed',
        '#adf9d0',
        '#970b79',
        '#757b23',
        '#f688a1',
        '#217d35',
        '#8c48c0',
        '#f29d47',
        '#120452',
        '#ec4aa8',
        '#6c681b',
    ]
}